import { TFunction } from 'i18next'
import { date, object, SchemaOf, string } from 'yup'

import { Account } from '@modules-deprecated/app/accounts/types'

export interface RegisterPaymentForm {
  billDate: Date | null | undefined
  paymentAccount: Partial<Account> | undefined
  paymentDate: Date | null | undefined
}

export const defaultValues: RegisterPaymentForm = {
  billDate: undefined,
  paymentAccount: undefined,
  paymentDate: undefined,
}

export type RegisterPaymentFormSchema = SchemaOf<RegisterPaymentForm>

export const getValidationSchema = (t: TFunction): RegisterPaymentFormSchema =>
  object({
    billDate: date().nullable(),
    paymentAccount: object({
      id: string().required(t('required_field')),
    })
      .required(t('required_field'))
      .typeError(t('required_field')),
    paymentDate: date()
      .nullable()
      .required(t('required_field'))
      .when('billDate', (billDate, schema) => {
        return billDate ? schema.min(billDate, t('bill.edit.form.validate.payment_date_before_bill_date')) : schema
      }),
  })
